import { Container, styled } from '@mui/material'

export const StyledContainer = styled(Container)(({ theme }) => ({
  flex: 1,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    marginTop: 'initial',
    justifyContent: 'center',
  },
}))
